import { createSlice } from "@reduxjs/toolkit";
import { getProductFeaturesAPI } from "../../services/getProductFeatures";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getProductFeaturesSlice = createSlice({
  name: "getProductFeatures",
  initialState: data,
  reducers: {
    getProductFeaturesInfo(state) {
      state.isLoading = true;
    },
    getProductFeaturesInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    getProductFeaturesInfoFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    getProductFeaturesInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getProductFeaturesHandler = (data) => async (dispatch) => {
  try {
    dispatch(getProductFeaturesAction.getProductFeaturesInfo());
    const response = await getProductFeaturesAPI(data);
    dispatch(getProductFeaturesAction.getProductFeaturesInfoSuccess(response));
  } catch (e) {
    dispatch(getProductFeaturesAction.getProductFeaturesInfoFailure(e?.response?.data?.message));
  }
};
export default getProductFeaturesSlice.reducer;
export const getProductFeaturesAction = getProductFeaturesSlice.actions;
